import { AWProposalPreferenceList } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

export const getProposalPreferences = async (proposalId: string, pkg: string) => {
  const path = `/v1/proposal-preferences/${proposalId}`;
  const response = await userPreferenceApi.get<AGraphWrappedType<AWProposalPreferenceList[], 'proposalPreferences'>>(
    path,
    { params: { pkg } }
  );
  return unwrapAGraphResponse(response, 'proposalPreferences');
};

export const postCreateProposalPreferences = async (
  proposalPreferenceList: AWProposalPreferenceList,
  proposalId: string,
  pkg: string
) => {
  const path = `/v1/proposal-preferences?proposalId=${proposalId}`;
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(path, proposalPreferenceList, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'id');
};

export const putUpdateProposalPreferences = async (
  proposalPreferenceList: AWProposalPreferenceList,
  proposalId: string
) => {
  const path = `/v1/proposal-preferences/${proposalId}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'result'>>(path, proposalPreferenceList);
  return unwrapAGraphResponse(response, 'result');
};

export const deleteProposalPreferences = (reqBody: string[], pkg: string) => {
  if (isAGraphEnabled()) {
    const path = `/v1/proposal-preferences:bulkDelete`;
    return userPreferenceApi.post(path, {
      data: { proposalIds: reqBody },
      params: { pkg },
    });
  }
  const path = `/v1/proposal-preferences`;
  return userPreferenceApi.delete(path, { data: reqBody, params: { pkg } });
};
